<script>
  import InstalledBaseView from './InstalledBaseView.svelte'
  import { installedBaseAPI } from './api.js'
  import { push } from 'svelte-spa-router'
  import Button from 'smelte/src/components/Button'
  import Metrics from '../Metrics.svelte'
  import { userStore, is, projectFilters } from '../../store'
  import { onMount, onDestroy } from 'svelte'
  import {faGlobeAmericas} from '@fortawesome/free-solid-svg-icons'
  import { arrayFilterByRoles, objectFilterByRoles } from '../../roles'

  export let params = {}

  const api = new installedBaseAPI()

  let locationLabel = 'Project number:'
  let mapTrigger = 0

  let _columns = [
    {
      label: 'Project number', field: 'su_erp_proj', add: '', w: '20', iconAfter: true
    },
    {
      label: 'Sales office', field: 'country_key', add: '', w: '12', iconAfter: true
    },
    {
      label: 'End user company', field: 'eu_name', add: '', w: 'auto', iconAfter: true
    },
    {
      label: 'End user country', field: 'eu_country', add: 'flex-shrink-1', w: 'auto', iconAfter: true
    },
    {
      label: 'Key account', field: 'GKAM', add: 'pr-3', w: '20', iconAfter: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      label: 'Service agreement', field: 'sa', add: '', w: '20', iconAfter: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      label: 'End service agreement', field: 'sa_end', add: '', w: '16', iconAfter: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      label: 'Warranty end date', field: 'WarrantyDate', add: '', w: '16', iconAfter: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      label: 'SAT signature date', field: 'SATDate', add: '', w: '16', iconAfter: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      label: 'Asset value', field: 'AssetValue', add: '', w: '40', currency: 'Currency', iconAfter: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      label: 'Operation center', field: 'op_center', add: '', w: '20', iconAfter: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    },

    // {label: 'ID', field: 'no', add: 'text-center', w: '20', iconAfter: true},
    // {label: 'Machine Model', field: 'model', add: '', w: '20', iconAfter: true},
    // {label: 'Sales unit', field: 'sales_unit', add: '', w: '20', iconAfter: true},
    // {label: 'Machine status', field: 'status', add: '', w: '20', iconAfter: true},
    // {label: 'Serial no.', field: 'sn', add: '', w: '20', iconAfter: true},
    // {label: 'Unit serial no.', field: 'unit_serial', add: '', w: '20', iconAfter: true},
    // {label: 'User', field: 'm_modified_by', add: '', w: '20', iconAfter: true},
    // {label: 'Modified', field: 'm_modified_fmt', add: '', w: '20', iconAfter: true},
  ]

  let exportColumns = [
    { label: 'Project Number', field: 'su_erp_proj'},
    { label: 'Sales office', field: 'country_key'},
    { label: 'End user company', field: 'eu_name'},
    { label: 'End user country', field: 'eu_country'},
    { label: 'Key account', field: 'GKAM'},
    { label: 'Service agreement', field: 'sa'},
    { label: 'End service agreement', field: 'sa_end'},
    { label: 'SAT signed?', field: 'is_sat'},
    { label: 'SAT signature date', field: 'SATDate'},
    { label: 'Warranty end date', field: 'WarrantyDate'},
    { label: 'Asset value', field: 'AssetValue'},
    { label: 'Operation center', field: 'op_center'},
    { label: 'Operation Center ERP project number', field: 'LinkedProject'},
    { label: 'Customer contact name', field: 'Reference'},
    { label: 'Customer contact email', field: 'Email'},
    { label: 'Ship to customer number', field: 'shcu_no'},
    { label: 'Ship to customer name', field: 'shcu_name'},
    { label: 'Ship to city', field: 'shcu_city'},
    { label: 'Ship to country', field: 'shcu_country'},
    { label: 'Ship to address', field: 'shcu_street'},
  ]

  $: actions = [
    {
      name: 'move_to_sales_office', hint: 'Relocate', icon: faGlobeAmericas,
      roles: ['ib_admin']
    }
  ].filter(p => is($userStore.roles, ...p.roles))

  let columns = []
  let filters = {}

  $: {
    columns = arrayFilterByRoles(_columns, $userStore.roles)
    filters = objectFilterByRoles($projectFilters, $userStore.roles)
  }

  onMount(() => {
    filters = $projectFilters
  })

  onDestroy(() => {
    $projectFilters = filters
  })

  let getMachines = function (locations, selectedLocation, resolve) {
    api.getMachinesByProject(selectedLocation._id)
      .then(res => {
        if (res.data && Array.isArray(res.data)) {
          let machines = res.data
          resolve(machines)
        }
      })
      .catch(err => {
        console.log('[ERROR]', err)
      })
  }

  let setLocationID = function (l) {
    l.no = l.su_erp_proj
    l.id = l.no
  }

  let locationsHandler = 'getProjectList'

  async function actionsHandler({detail}) {
    if (detail.action.name === 'move_to_sales_office') {

        api.setProjectToSalesOfficeLocation(detail.item)
          .then(res => {
            console.log('[DEBUG] action: move to sales office', detail.item.su_erp_proj, detail.item.country_key)
            console.log('[DEBUG] office location', res.data)
            if (!Array.isArray(res.data) || res.data.length !== 2) {
              console.log('[ERROR] bad data response, expected array [x, y]:', res.data)
            }
            detail.item.lat = res.data[0].toString()
            detail.item.lon = res.data[1].toString()
            mapTrigger += 1
          })
          .catch(err => console.log('[ERROR]', err))
      }
  }

</script>

<Metrics />

<div class="mx-10 md:mx-12 lg:mx-12 ">
  <InstalledBaseView
    {params}
    {locationLabel}
    {columns}
    {actions}
    {filters}
    {getMachines}
    {setLocationID}
    {locationsHandler}
    bind:mapTrigger={mapTrigger}
    on:action={actionsHandler}
    {exportColumns}
  >
  <span slot="action-buttons">
    <Button text color="red"
            style="margin-left: -12px; text-align: left"
            on:click={() => { push('/installed-base/conveyors') }}>
      Show conveyor/machine view
    </Button>
  </span>
  </InstalledBaseView>
</div>